<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterMonth"
              :editedCustomerIndex="-1"
              :customerName="'quotation_shortname'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_item_month_number')"
              v-model="filterMonth.Number"
              @input="getAllMonth"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterMonth.LicensePlate"
              @input="getAllMonth"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="monthDataTableHeaders"
      :items="monthList"
      class="elevation-1 my-5"
      :loading="isLoadingMonth"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('month_tool_bar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="isShowEditMonthDialog" fullscreen persistent>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t('common_look') }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.Number"
                        :label="$t('quotation_item_month_number')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.ItemNumber"
                        :label="$t('month_number')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.ItemName"
                        :label="$t('month_name')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.CustomerNumber"
                        :label="$t('quotation_customer_number')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.CustomerName"
                        :label="$t('quotation_shortname')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.CustomerFullName"
                        :label="$t('quotation_full_name')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.LicensePlate"
                        :label="$t('quotation_license_plate')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.MonthQuantity"
                        :label="$t('month_quantity')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.PayQuantity"
                        label="計量數量"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.OverageMonthQuantity"
                        label="預繳期數"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnStartDate"
                        :label="$t('month_start_date')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnEndDate"
                        :label="$t('month_end_date')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnStopDate"
                        :label="$t('month_stop_date')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnDoneDate"
                        :label="$t('month_done_date')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.OriginalCurrency"
                        :label="$t('month_original_currency')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.DomesticCurrency"
                        :label="$t('month_domestic_currency')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnPayTimeRangeType"
                        label="計費時間"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.RentWarrantyPeriod"
                        :label="$t('quotation_item_rent_warranty_period')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.RentDay"
                        :label="$t('month_rent_day')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnMonthStatus"
                        :label="$t('month_rent_status')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                      <v-autocomplete
                        v-model="editedMonth.PayType"
                        :items="allPayType"
                        item-text="Name"
                        item-value="Type"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_data')"
                        label="收款方式"
                        disabled
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                      lg="3"
                      xl="3"
                      v-if="editedMonth.PayType === payType.Quantity"
                    >
                      <v-autocomplete
                        v-model="editedMonth.PayQuantityType"
                        :items="allPayQuantityType"
                        item-text="Name"
                        item-value="Type"
                        label="計量方式"
                        disabled
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.GiveWarrantyPeriod"
                        :label="$t('discount_item_give_warranty_period')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnExpectedRemoveDate"
                        :label="$t('month_expected_remove_date')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.UnUseDay"
                        :label="$t('month_not_use_day')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="editedMonth.UseDay"
                        :label="$t('month_use_day')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="turnLastPayDate"
                        :label="$t('month_last_pay_date')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-checkbox
                        v-model="editedMonth.IsEnd"
                        :label="$t('month_is_end')"
                        disabled
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-textarea
                        outlined
                        v-model="editedMonth.Remark"
                        :label="$t('quotation_item_remark')"
                        disabled
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-tabs>
                <v-tab href="#tab-1">{{ $t('month_item_tab') }}</v-tab>
                <v-tab href="#tab-2">{{ $t('month_sale_item_tab') }}</v-tab>
                <v-tab href="#tab-3">{{ $t('month_return_pay_tab') }}</v-tab>
                <v-tab href="#tab-4">續約明細</v-tab>
                <v-tab href="#tab-5">違約明細</v-tab>

                <v-tab-item value="tab-1">
                  <v-card flat>
                    <v-card-text>
                      <v-data-table
                        :headers="monthItemDataTableHeaders"
                        :items="editedMonth.MonthItems"
                        :search="searchMonthItem"
                        class="elevation-1"
                        :no-data-text="$t('common_no_data')"
                        :no-results-text="$t('common_no_results')"
                        :footer-props="{
                          'items-per-page-options': [30, 50, 100],
                          'items-per-page-text': $t('item_rows_per_page'),
                        }"
                      >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-spacer></v-spacer>
                            <v-text-field
                              v-model="searchMonthItem"
                              append-icon="mdi-magnify"
                              :label="$t('quotation_item_new_install_search')"
                              single-line
                              hide-details
                              clearable
                            ></v-text-field>
                          </v-toolbar>
                        </template>
                        <template v-slot:[`item.ChangeDate`]="{ item }">
                          {{ convertToDateTimeFormat(item.ChangeDate) }}
                        </template>
                        <template v-slot:[`item.MonthItemStatus`]="{ item }">
                          {{ turnMonthItem(item.MonthItemStatus) }}
                        </template>
                        <template v-slot:[`item.NumberType`]="{ item }">
                          {{ turnNumberType(item.NumberType) }}
                        </template>
                        <template v-slot:[`item.IsPenaltyRequired`]="{ item }">
                          <v-icon>
                            {{ item.IsPenaltyRequired ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-2">
                  <v-card flat>
                    <v-card-text>
                      <v-data-table
                        :headers="saleItemDataTableHeaders"
                        :items="editedMonth.NewSaleItems"
                        :search="searchSaleItem"
                        class="elevation-1"
                        :no-data-text="$t('common_no_data')"
                        :no-results-text="$t('common_no_results')"
                        :footer-props="{
                          'items-per-page-options': [30, 50, 100],
                          'items-per-page-text': $t('item_rows_per_page'),
                        }"
                      >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-spacer></v-spacer>
                            <v-text-field
                              v-model="searchSaleItem"
                              append-icon="mdi-magnify"
                              :label="$t('quotation_item_new_install_search')"
                              single-line
                              hide-details
                              clearable
                            ></v-text-field>
                          </v-toolbar>
                        </template>
                        <template v-slot:[`item.ThrowDate`]="{ item }">
                          {{ convertToDateTimeFormat(item.ThrowDate) }}
                        </template>
                        <template v-slot:[`item.StartDate`]="{ item }">
                          {{ convertToDateTimeFormat(item.StartDate) }}
                        </template>
                        <template v-slot:[`item.EndDate`]="{ item }">
                          {{ convertToDateTimeFormat(item.EndDate) }}
                        </template>
                        <template v-slot:[`item.PayType`]="{ item }">
                          {{ turnPayType(item.PayType) }}
                        </template>
                        <template v-slot:[`item.Edit`]="{ item }">
                          <v-btn icon @click="isShowEditNewSaleItemBtn(item)">
                            <v-icon small>
                              mdi-eye
                            </v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                      <v-dialog v-model="isShowEditNewSaleItem" max-width="800" persistent>
                        <v-card>
                          <v-card-title>
                            <span class="text-h5"></span>
                          </v-card-title>
                          <v-card-text>
                            <v-container>
                              <v-data-table
                                :headers="recordSaleItemDataTableHeaders"
                                :items="editedNewSaleItem.RecordSaleItems"
                                :search="searchRecordSaleItem"
                                class="elevation-1"
                                :no-data-text="$t('common_no_data')"
                                :no-results-text="$t('common_no_results')"
                                :footer-props="{
                                  'items-per-page-options': [30, 50, 100],
                                  'items-per-page-text': $t('item_rows_per_page'),
                                }"
                              >
                                <template v-slot:top>
                                  <v-toolbar flat>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                      v-model="searchRecordSaleItem"
                                      append-icon="mdi-magnify"
                                      :label="$t('quotation_item_new_install_search')"
                                      single-line
                                      hide-details
                                      clearable
                                    ></v-text-field>
                                  </v-toolbar>
                                </template>
                                <template v-slot:[`item.StartDate`]="{ item }">
                                  {{ convertToDateTimeFormat(item.StartDate) }}
                                </template>
                                <template v-slot:[`item.EndDate`]="{ item }">
                                  {{ convertToDateTimeFormat(item.EndDate) }}
                                </template>
                              </v-data-table>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="red darken-1"
                              text
                              @click="closeEditedNewSaleItem"
                              :disabled="isAllTextFieldDisable"
                            >
                              {{ $t('common_cancel') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-3">
                  <v-card flat>
                    <v-card-text>
                      <v-data-table
                        :headers="returnMonthPayDataTableHeaders"
                        :items="editedMonth.ReturnMonthPayList"
                        :search="searchReturnMonthPay"
                        class="elevation-1"
                        :no-data-text="$t('common_no_data')"
                        :no-results-text="$t('common_no_results')"
                        :footer-props="{
                          'items-per-page-options': [30, 50, 100],
                          'items-per-page-text': $t('item_rows_per_page'),
                        }"
                      >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-spacer></v-spacer>
                            <v-text-field
                              v-model="searchReturnMonthPay"
                              append-icon="mdi-magnify"
                              :label="$t('quotation_item_new_install_search')"
                              single-line
                              hide-details
                              clearable
                            ></v-text-field>
                          </v-toolbar>
                        </template>
                        <template v-slot:[`item.OwePayTime`]="{ item }">
                          {{ convertToDateTimeFormat(item.OwePayTime) }}
                        </template>
                        <template v-slot:[`item.Edit`]="{ item }">
                          <v-btn icon @click="isShowEditReturnMonthPayBtn(item)">
                            <v-icon small>
                              mdi-eye
                            </v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                      <v-dialog v-model="isShowEditReturnMonthPay" max-width="800" persistent>
                        <v-card>
                          <v-card-title>
                            <span class="text-h5"></span>
                          </v-card-title>
                          <v-card-text>
                            <v-container>
                              <v-tabs>
                                <v-tab href="#tab-1">{{
                                  $t('month_return_pay_owe_record_tab')
                                }}</v-tab>
                                <v-tab href="#tab-2">{{
                                  $t('month_return_pay_return_record_tab')
                                }}</v-tab>
                                <v-tab-item value="tab-1">
                                  <v-data-table
                                    :headers="oweRecordDataTableHeaders"
                                    :items="editedReturnMonthPay.OweRecordList"
                                    :search="searchOweRecord"
                                    class="elevation-1 ma-2"
                                    :no-data-text="$t('common_no_data')"
                                    :no-results-text="$t('common_no_results')"
                                    :footer-props="{
                                      'items-per-page-options': [30, 50, 100],
                                      'items-per-page-text': $t('item_rows_per_page'),
                                    }"
                                  >
                                    <template v-slot:top>
                                      <v-toolbar flat>
                                        <v-spacer></v-spacer>
                                        <v-text-field
                                          v-model="searchOweRecord"
                                          append-icon="mdi-magnify"
                                          :label="$t('quotation_item_new_install_search')"
                                          single-line
                                          hide-details
                                          clearable
                                        ></v-text-field>
                                      </v-toolbar>
                                    </template>
                                    <template v-slot:[`item.OweStartTime`]="{ item }">
                                      {{ convertToDateTimeFormat(item.OweStartTime) }}
                                    </template>
                                    <template v-slot:[`item.OweEndTime`]="{ item }">
                                      {{ convertToDateTimeFormat(item.OweEndTime) }}
                                    </template>
                                  </v-data-table>
                                </v-tab-item>
                                <v-tab-item value="tab-2">
                                  <v-data-table
                                    :headers="returnRecordDataTableHeaders"
                                    :items="editedReturnMonthPay.ReturnRecordList"
                                    :search="searchReturnRecord"
                                    class="elevation-1 ma-2"
                                    :no-data-text="$t('common_no_data')"
                                    :no-results-text="$t('common_no_results')"
                                    :footer-props="{
                                      'items-per-page-options': [30, 50, 100],
                                      'items-per-page-text': $t('item_rows_per_page'),
                                    }"
                                  >
                                    <template v-slot:top>
                                      <v-toolbar flat>
                                        <v-spacer></v-spacer>
                                        <v-text-field
                                          v-model="searchReturnRecord"
                                          append-icon="mdi-magnify"
                                          :label="$t('quotation_item_new_install_search')"
                                          single-line
                                          hide-details
                                          clearable
                                        ></v-text-field>
                                      </v-toolbar>
                                    </template>
                                    <template v-slot:[`item.ReturnPayTime`]="{ item }">
                                      {{ convertToDateTimeFormat(item.ReturnPayTime) }}
                                    </template>
                                  </v-data-table>
                                </v-tab-item>
                              </v-tabs>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="closeEditedReturnMonthPay">
                              {{ $t('common_cancel') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-4">
                  <v-card flat>
                    <v-card-text>
                      <v-data-table
                        :headers="renewMonthItemDataTableHeaders"
                        :items="editedMonth.RenewMonthItems"
                        :search="searchRenewMonthItem"
                        class="elevation-1"
                        :no-data-text="$t('common_no_data')"
                        :no-results-text="$t('common_no_results')"
                        :footer-props="{
                          'items-per-page-options': [30, 50, 100],
                          'items-per-page-text': $t('item_rows_per_page'),
                        }"
                      >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-spacer></v-spacer>
                            <v-text-field
                              v-model="searchRenewMonthItem"
                              append-icon="mdi-magnify"
                              :label="$t('quotation_item_new_install_search')"
                              single-line
                              hide-details
                              clearable
                            ></v-text-field>
                          </v-toolbar>
                        </template>
                        <template v-slot:[`item.ChangeTime`]="{ item }">
                          {{ convertToDateTimeFormat(item.ChangeTime) }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-5">
                  <v-card flat>
                    <v-card-text>
                      <v-data-table
                        :headers="penaltyMonthItemDataTableHeaders"
                        :items="editedMonth.PenaltyMonthItems"
                        :search="searchPenaltyMonthItem"
                        class="elevation-1"
                        :no-data-text="$t('common_no_data')"
                        :no-results-text="$t('common_no_results')"
                        :footer-props="{
                          'items-per-page-options': [30, 50, 100],
                          'items-per-page-text': $t('item_rows_per_page'),
                        }"
                      >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-spacer></v-spacer>
                            <v-text-field
                              v-model="searchPenaltyMonthItem"
                              append-icon="mdi-magnify"
                              :label="$t('quotation_item_new_install_search')"
                              single-line
                              hide-details
                              clearable
                            ></v-text-field>
                          </v-toolbar>
                        </template>
                        <template v-slot:[`item.RecordTime`]="{ item }">
                          {{ convertToDateTimeFormat(item.RecordTime) }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="closeEditedMonth">
                  {{ $t('common_cancel') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditMonthBtn(item)">
          <v-icon small>
            mdi-eye
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.MonthStatus`]="{ item }">
        {{ turnMonthStatusName(item.MonthStatus) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { HttpMonth } from '@/js/http-Manager'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import { MonthStatus } from '@/js/MonthStatus'
import { MonthItemStatus } from '@/js/MonthItemStatus'
import { NumberType } from '@/js/NumberType'
import { PayType } from '@/js/PayType'
import { PayTimeRangeType } from '@/js/PayTimeRangeType'

export default {
  name: 'NewMonth',
  components: { CustomerAutocompleteFilter },
  data: () => ({
    isShowEditMonthDialog: false,
    monthList: [],
    editedMonthIndex: -1,
    allPayQuantityType: [],
    payType: PayType,
    editedMonth: {
      Number: '',
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      LicensePlate: '',
      MonthQuantity: 0,
      OverageMonthQuantity: 0,
      StartDate: 0,
      EndDate: 0,
      StopDate: 0,
      DoneDate: 0,
      OriginalCurrency: 0,
      DomesticCurrency: 0,
      RentWarrantyPeriod: 0,
      RentDay: 0,
      MonthStatus: 0,
      GiveWarrantyPeriod: 0,
      ExpectedRemoveDate: 0,
      UnUseDay: 0,
      UseDay: 0,
      IsEnd: false,
      LastPayDate: 0,
      MonthItems: [],
      SaleItems: [],
      NewSaleItems: [],
      ReturnMonthPayList: [],
      PenaltyMonthItems: [],
      RenewMonthItems: [],
      Remark: '',
      PayTimeRangeType: 1
    },
    defaultMonth: {
      Number: '',
      CustomerId: '',
      ItemId: '',
      LicensePlate: '',
      MonthQuantity: 0,
      OverageMonthQuantity: 0,
      StartDate: 0,
      EndDate: 0,
      StopDate: 0,
      DoneDate: 0,
      OriginalCurrency: 0,
      DomesticCurrency: 0,
      RentWarrantyPeriod: 0,
      RentDay: 0,
      MonthStatus: 0,
      GiveWarrantyPeriod: 0,
      ExpectedRemoveDate: 0,
      UnUseDay: 0,
      UseDay: 0,
      IsEnd: false,
      LastPayDate: 0,
      MonthItems: [],
      SaleItems: [],
      NewSaleItems: [],
      ReturnMonthPayList: [],
      PenaltyMonthItems: [],
      RenewMonthItems: [],
      Remark: '',
      PayTimeRangeType: 1
    },
    isLoadingMonth: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    isShowDeleteMonthDialog: false,
    isLoadingDeleteBtn: false,
    isDeleteBtnDisable: false,
    currentOptions: {
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isUpdateEventTotal: true,
    totalRows: 0,
    filterMonth: {
      Number: '',
      CustomerId: '',
      LicensePlate: ''
    },
    searchMonthItem: '',
    searchSaleItem: '',
    isShowEditNewSaleItem: false,
    searchRecordSaleItem: '',
    editedNewSaleItemIndex: -1,
    editedNewSaleItem: {
      SettleDay: 0,
      OriginalCurrency: 0,
      DomesticCurrency: 0,
      SaleType: '',
      SaleNumber: '',
      SaleSort: '',
      ThrowDate: 0,
      StartDate: 0,
      EndDate: 0,
      PayDay: 0,
      PayType: 0,
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      MonthQuantity: 0,
      Remark: '',
      RecordSaleItems: []
    },
    defaultNewSaleItem: {
      SettleDay: 0,
      OriginalCurrency: 0,
      DomesticCurrency: 0,
      SaleType: '',
      SaleNumber: '',
      SaleSort: '',
      ThrowDate: 0,
      StartDate: 0,
      EndDate: 0,
      PayDay: 0,
      PayType: 0,
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      MonthQuantity: 0,
      Remark: '',
      RecordSaleItems: []
    },
    searchReturnMonthPay: '',
    isShowEditReturnMonthPay: false,
    searchOweRecord: '',
    searchReturnRecord: '',
    editedReturnMonthPayIndex: -1,
    editedReturnMonthPay: {
      OwePayTime: 0,
      OweDay: 0,
      OwePay: 0,
      OweRecordList: [],
      ReturnRecordList: [],
      IsReturnPay: false,
      ReturnPay: 0,
      RestOfPay: 0
    },
    defaultReturnMonthPay: {
      OwePayTime: 0,
      OweDay: 0,
      OwePay: 0,
      OweRecordList: [],
      ReturnRecordList: [],
      IsReturnPay: false,
      ReturnPay: 0,
      RestOfPay: 0
    },
    allPayType: [],
    searchRenewMonthItem: '',
    searchPenaltyMonthItem: ''
  }),
  async mounted () {
    await this.getAllMonth()
    await this.countTotalRows()
    await this.getAllPayType()
    await this.getAllPayQuantityType()
  },
  computed: {
    monthDataTableHeaders () {
      return [
        {
          text: this.$t('quotation_item_month_number'),
          align: 'start',
          value: 'Number'
        },
        { text: this.$t('quotation_customer_number'), align: 'start', value: 'CustomerNumber' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        { text: this.$t('item_number'), align: 'start', value: 'ItemNumber' },
        { text: this.$t('item_name'), align: 'start', value: 'ItemName' },
        {
          text: this.$t('quotation_license_plate'),
          align: 'start',
          value: 'LicensePlate'
        },
        {
          text: this.$t('quotation_item_rent_warranty_period'),
          align: 'end',
          value: 'RentWarrantyPeriod'
        },
        {
          text: this.$t('month_rent_status'),
          align: 'end',
          value: 'MonthStatus'
        },
        {
          text: this.$t('month_original_currency'),
          align: 'end',
          value: 'OriginalCurrency'
        },
        {
          text: this.$t('month_domestic_currency'),
          align: 'end',
          value: 'DomesticCurrency'
        },
        {
          text: this.$t('common_look'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    dialogTitleHeader () {
      return this.editedMonthIndex === -1
        ? this.$t('point_new_card_title')
        : this.$t('point_edited_card_title')
    },
    turnStartDate () {
      return this.convertToDateTimeFormat(this.editedMonth.StartDate)
    },
    turnEndDate () {
      return this.convertToDateTimeFormat(this.editedMonth.EndDate)
    },
    turnStopDate () {
      return this.convertToDateTimeFormat(this.editedMonth.StopDate)
    },
    turnDoneDate () {
      return this.convertToDateTimeFormat(this.editedMonth.DoneDate)
    },
    turnExpectedRemoveDate () {
      return this.convertToDateTimeFormat(this.editedMonth.ExpectedRemoveDate)
    },
    turnLastPayDate () {
      return this.convertToDateTimeFormat(this.editedMonth.LastPayDate)
    },
    turnMonthStatus () {
      return MonthStatus.MonthStatusName(this.editedMonth.MonthStatus)
    },
    monthItemDataTableHeaders () {
      return [
        {
          text: this.$t('month_item_change_date'),
          align: 'start',
          value: 'ChangeDate'
        },
        { text: this.$t('month_item_status'), align: 'start', value: 'MonthItemStatus' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        {
          text: this.$t('quotation_license_plate'),
          align: 'start',
          value: 'LicensePlate'
        },
        { text: this.$t('month_quantity'), align: 'start', value: 'MonthQuantity' },
        { text: '計量數量', align: 'start', value: 'PayQuantity' },
        { text: '停止計量數量', align: 'start', value: 'StopPayQuantity' },
        { text: '新增量數量', align: 'start', value: 'AddPayQuantity' },
        {
          text: this.$t('month_item_is_throw_sale_detail'),
          align: 'start',
          value: 'IsThrowSaleDetail'
        },
        { text: this.$t('month_item_number_type'), align: 'start', value: 'NumberType' },
        { text: this.$t('month_item_original_number'), align: 'start', value: 'OriginalNumber' },
        { text: '是否需要支付違約金', align: 'start', value: 'IsPenaltyRequired' }
      ]
    },
    saleItemDataTableHeaders () {
      return [
        {
          text: this.$t('month_sale_item_settle_day'),
          align: 'start',
          value: 'SettleDay'
        },
        { text: this.$t('month_original_currency'), align: 'start', value: 'OriginalCurrency' },
        { text: this.$t('month_domestic_currency'), align: 'start', value: 'DomesticCurrency' },
        {
          text: this.$t('month_sale_item_sale_type'),
          align: 'start',
          value: 'SaleType'
        },
        { text: this.$t('month_sale_item_sale_number'), align: 'start', value: 'SaleNumber' },
        { text: this.$t('month_sale_item_sale_sort'), align: 'start', value: 'SaleSort' },
        { text: this.$t('month_sale_item_throw_date'), align: 'start', value: 'ThrowDate' },
        { text: this.$t('month_sale_item_start_date'), align: 'start', value: 'StartDate' },
        { text: this.$t('month_sale_item_end_date'), align: 'start', value: 'EndDate' },
        { text: this.$t('month_sale_item_pay_day'), align: 'start', value: 'PayDay' },
        { text: this.$t('month_sale_item_pay_type'), align: 'start', value: 'PayType' },
        { text: this.$t('quotation_customer_number'), align: 'start', value: 'CustomerNumber' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        { text: this.$t('quotation_license_plate'), align: 'start', value: 'LicensePlate' },
        { text: this.$t('month_quantity'), align: 'start', value: 'MonthQuantity' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        {
          text: this.$t('common_look'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    recordSaleItemDataTableHeaders () {
      return [
        {
          text: this.$t('month_sale_item_start_date'),
          align: 'start',
          value: 'StartDate'
        },
        { text: this.$t('month_sale_item_end_date'), align: 'start', value: 'EndDate' },
        { text: this.$t('month_sale_item_pay_day'), align: 'end', value: 'PayDay' }
      ]
    },
    returnMonthPayDataTableHeaders () {
      return [
        {
          text: this.$t('month_return_pay_owe_time'),
          align: 'start',
          value: 'OwePayTime'
        },
        { text: this.$t('month_return_pay_owe_day'), align: 'start', value: 'OweDay' },
        { text: this.$t('month_return_pay_owe_pay'), align: 'start', value: 'OwePay' },
        {
          text: this.$t('month_return_pay_is_return'),
          align: 'start',
          value: 'IsReturnPay'
        },
        { text: this.$t('month_return_pay_return_pay'), align: 'start', value: 'ReturnPay' },
        { text: this.$t('month_return_pay_return_pay_total'), align: 'start', value: 'RestOfPay' },
        {
          text: this.$t('common_look'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    oweRecordDataTableHeaders () {
      return [
        {
          text: this.$t('month_sale_item_start_date'),
          align: 'start',
          value: 'OweStartTime'
        },
        { text: this.$t('month_sale_item_end_date'), align: 'start', value: 'OweEndTime' },
        { text: this.$t('month_sale_item_pay_day'), align: 'end', value: 'OweDay' }
      ]
    },
    returnRecordDataTableHeaders () {
      return [
        {
          text: this.$t('month_return_pay_return_time'),
          align: 'start',
          value: 'ReturnPayTime'
        },
        { text: this.$t('month_return_pay_return_pay'), align: 'start', value: 'ReturnPay' },
        { text: this.$t('installation_notice_sale_number'), align: 'end', value: 'SaleNumber' }
      ]
    },
    turnPayTimeRangeType () {
      return PayTimeRangeType.PayTimeRangeTypeName(this.editedMonth.PayTimeRangeType)
    },
    renewMonthItemDataTableHeaders () {
      return [
        {
          text: this.$t('month_item_change_date'),
          align: 'start',
          value: 'ChangeTime'
        },
        {
          text: '原月租保固期數',
          align: 'end',
          value: 'OriginalRentWarrantyPeriod'
        },
        {
          text: '增加保固期數',
          align: 'end',
          value: 'AddRentWarrantyPeriod'
        },
        {
          text: '總保固期數',
          align: 'end',
          value: 'TotalRentWarrantyPeriod'
        },
        {
          text: '續約原因',
          align: 'start',
          value: 'RenewReason'
        }
      ]
    },
    penaltyMonthItemDataTableHeaders () {
      return [
        {
          text: '紀錄時間',
          align: 'start',
          value: 'RecordTime'
        },
        {
          text: '剩餘天數',
          align: 'end',
          value: 'UnUseDay'
        },
        {
          text: '原幣罰金',
          align: 'end',
          value: 'OriginalPenaltyCurrency'
        },
        {
          text: '本幣罰金',
          align: 'end',
          value: 'DomesticPenaltyCurrency'
        },
        {
          text: this.$t('month_sale_item_sale_type'),
          align: 'start',
          value: 'SaleType'
        },
        { text: this.$t('month_sale_item_sale_number'), align: 'start', value: 'SaleNumber' },
        { text: this.$t('month_sale_item_sale_sort'), align: 'start', value: 'SaleSort' }
      ]
    }
  },
  methods: {
    async getAllPayQuantityType () {
      let response = await HttpMonth.GetAllPayQuantityType()
      if (response && response.status === 200) {
        this.allPayQuantityType = response.data.Data
      }
    },
    turnMonthStatusName (val) {
      return MonthStatus.MonthStatusName(val)
    },
    async getAllPayType () {
      let response = await HttpMonth.GetAllPayType()
      this.allPayType = response.status === 200 ? response.data.Data : []
    },
    turnNumberType (val) {
      return NumberType.NumberTypeName(val)
    },
    turnPayType (val) {
      return PayType.PayTypeName(val)
    },
    turnMonthItem (val) {
      return MonthItemStatus.MonthItemStatusName(val)
    },
    async setFilterCustomer (val) {
      this.filterMonth.CustomerId = val.Id
      this.filterMonth = JSON.parse(JSON.stringify(this.filterMonth))
      await this.getAllMonth()
      await this.countTotalRows()
    },
    async getAllMonth (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isLoadingMonth = true
      let param = {
        Number: this.filterMonth.Number,
        CustomerId: this.filterMonth.CustomerId,
        LicensePlate: this.filterMonth.LicensePlate,
        ItemsPerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy,
        SortDesc: typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortBy
      }
      let response = await HttpMonth.GetMonth(param)
      this.isLoadingMonth = false
      this.monthList = response.status === 200 ? response.data.Data : []
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          Number: this.filterMonth.Number,
          CustomerId: this.filterMonth.CustomerId,
          LicensePlate: this.filterMonth.LicensePlate
        }
        let response = await HttpMonth.GetMonthCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getAllMonth(val)
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditMonthBtn (item) {
      this.editedMonthIndex = this.monthList.indexOf(item)
      this.editedMonth = JSON.parse(JSON.stringify(item))
      this.isShowEditMonthDialog = true
    },
    closeEditedMonth () {
      this.isShowEditMonthDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false

      this.$nextTick(() => {
        this.editedMonth = JSON.parse(JSON.stringify(this.defaultMonth))
        this.editedMonthIndex = -1
      })
    },
    isShowEditNewSaleItemBtn (item) {
      this.editedNewSaleItemIndex = this.editedMonth.NewSaleItems.indexOf(item)
      this.editedNewSaleItem = JSON.parse(JSON.stringify(item))
      this.isShowEditNewSaleItem = true
    },
    closeEditedNewSaleItem () {
      this.isShowEditNewSaleItem = false

      this.$nextTick(() => {
        this.editedNewSaleItem = JSON.parse(JSON.stringify(this.defaultNewSaleItem))
        this.editedNewSaleItemIndex = -1
      })
    },
    isShowEditReturnMonthPayBtn (item) {
      this.editedReturnMonthPayIndex = this.editedMonth.ReturnMonthPayList.indexOf(item)
      this.editedReturnMonthPay = JSON.parse(JSON.stringify(item))
      this.isShowEditReturnMonthPay = true
    },
    closeEditedReturnMonthPay () {
      this.isShowEditReturnMonthPay = false

      this.$nextTick(() => {
        this.editedReturnMonthPay = JSON.parse(JSON.stringify(this.defaultReturnMonthPay))
        this.editedReturnMonthPayIndex = -1
      })
    }
  }
}
</script>
